import React from 'react';
import Avatar from './Avatar';

const DashboardHeader = ({ client }) => {
  if (!client) return null;

  return (
    <div className="chat-list-header">
      <div className="chat-list-header-left">
        <Avatar name={client.name || 'B'} size={36} />
        <div className="sidebar-header-titles">
          <h3 className="client-title">{client.name}</h3>
        </div>
      </div>
      {client.whatsapp_number && (
        <div className="client-number-badge" title={client.whatsapp_number}>
          <span>{client.whatsapp_number}</span>
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
